import customSelect from '../vendor/custom-select';
import helpers from './helpers';

export default (function () {
  return {
    init() {
      this.initSelect();
    },

    initSelect() {
      const selectElems = document.querySelectorAll('.js-custom-select');

      if (selectElems.length === 0) return;

      helpers.forEach(selectElems, (i, select) => {
        // apply custom styling
        customSelect(select);
        // change image on select change
        if (select.classList.contains('product-list__select')) {
          select.addEventListener('change', (e) => {
            const parent = e.target.closest('.product-list__product');
            const { value } = e.target;
            const { innerText } = e.target;
            if (parent) {
              const image = parent.querySelector('.js-switch-image');

              image.src = value;
              image.alt = innerText;

              const selectedOption = e.target.options[e.target.selectedIndex];
              const selectedUrl = selectedOption.dataset.url;
              const link = parent.querySelector('.js-product-list-btn');
              link.href = selectedUrl;
            }
          });
        }
      });
    },
  };
})();
